import React, { useState } from "react";
import styled from "styled-components";

import { PrimaryButton } from "../../atoms/Buttons";
import AddTeamMember from "./member.add";
import { TeamList } from "./team.list";

const Overlay = styled.div`
  background: #ffffff98;
  z-index: 2;
  width: 100%;
  height: 100%;
  position: absolute;
`;

const Team = () => {
  const [mode, setMode] = useState("default");

  return (
    <div className="flex pt-10">
      <div
        className="flex-grow pr-4 relative"
        style={{
          height: "fit-content",
        }}
      >
        {mode === "add-member" && <Overlay />}
        <TeamList />
      </div>
      {mode === "default" && (
        <div className=" pl-4 text-right">
          <PrimaryButton onClick={() => setMode("add-member")}>
            Add Team Member
          </PrimaryButton>
        </div>
      )}
      {mode === "add-member" && (
        <div className="w-1/2 pl-4">
          <AddTeamMember setMode={setMode} />
        </div>
      )}
    </div>
  );
};

export default Team;
